<template>
    <MainContent :title="'Editar ' + configuracion.simpatizante">
        <template v-slot:header>
            <h3 class="card-title">Datos del {{ configuracion.simpatizante }}: {{ abonado.nombre }} {{ abonado.apellidos }}</h3>
        </template>
        <template v-slot:content>
            <div class="row">
                <div class="col-12">
                    <FormComponent :abonado="abonado" @submit="editarAbonado"/>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import FormComponent from '@/components/backend/simpatizantes/FormComponent';

    export default {
        props: ['simpatizante_id'],
        data() {
            return {
                abonado: null,
                loading: true,
            }
        },
        created() {
            this.getAbonado();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            editarAbonado() {
                this.loading = true;

                this.abonado.filters = {};

                this.abonado.simpatizante_id = this.simpatizante_id;

                this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.editar'), this.abonado).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.simpatizantes.index' });
                }).finally(() => this.loading = false);
            },
            getAbonado : function() {
                this.loading = true;

                const params = {
                    filters : {},
                    simpatizante_id: this.simpatizante_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.show'), params).then(res => {
                    this.abonado = res.data.data;
                }).finally(() => this.loading = false);
            }
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>
